import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { UpdateProjectDto } from '../../../commonTypes/project.types';
import { dispatch } from '../../../store';
import { editProject, invalidateProjectsCache, invalidateProjectMetrics } from '../../../store/slices/projects.slice';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';

export interface ProjectToUpdate {
    projectId: string;
    updateProject: UpdateProjectDto;
}

const useHttpPatchProject = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');
    const navigate = useNavigate();

    const execSubmit = (id: string, body: UpdateProjectDto) => {
        const { exec, abort } = projectApi.update({
            params: { id },
            body,
            onSuccess: _ => {
                dispatch(editProject({ projectId: id, updateProject: body }));
                dispatch(invalidateProjectsCache());
                dispatch(invalidateProjectMetrics(id));
                toastHandler.push('success', t('projects.projectUpdateTitle'), t('projects.projectUpdateMessage_Success'));
                navigate(`/project/${id}?refresh=true`, { replace: true });
            },
            onError: _ => toastHandler.push('error', t('projects.projectUpdateTitle'), t('projects.projectUpdateMessage_Failed')),
        });
        exec();
        return abort;
    };

    return { execSubmit };
};

export default useHttpPatchProject;
